export enum OpnPlatformType {
	LOS,
	CommunityLending
}